import { createApi } from '../common/API'


export const fetchMyLoops = createApi('/loop/queryAllMyLoops', {expandData: false, method:'POST'});

export const getMyRecentPacks = createApi('/pack/getMyRecentPacks', {method:'POST'});
